import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_tooltip = _resolveComponent("tooltip")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['gfu-block-editor-prefix', { '_jcc': $props.iconPosition === 'center' }])
  }, [
    ($props.icon)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          ($props.iconDescription)
            ? (_openBlock(), _createBlock(_component_tooltip, {
                key: 0,
                text: $props.iconDescription
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_base_icon, {
                    name: $props.icon,
                    draggable: "false"
                  }, null, 8 /* PROPS */, ["name"])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["text"]))
            : (_openBlock(), _createBlock(_component_base_icon, {
                key: 1,
                name: $props.icon,
                draggable: "false"
              }, null, 8 /* PROPS */, ["name"]))
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}